import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import ReactDropzone from 'react-dropzone';
import withStyles from 'material-ui/styles/withStyles';
import Paper from 'material-ui/Paper';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import TodayIcon from '@material-ui/icons/Today';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AppBar from 'material-ui/AppBar';
import Card, { CardContent } from 'material-ui/Card';
import { Button, CircularProgress, InputAdornment, MenuItem } from 'material-ui';
import getEnvironmentFromUrl from '../../helpers/GetEnvironment';

import Layout from '../Layout';
import normalizePhone from '../../helpers/NormalizePhone';
import normalizeMaxLength from '../../helpers/NormalizeMaxLength';
import renderTextField from '../../helpers/RenderTextFiledWithDiv';
import renderTextAreaWithDiv from '../../helpers/RenderTextAreaWithDiv';
import renderSelectField from '../../helpers/RenderSelectField';
import renderDatePicker from '../../helpers/RenderDatePicker';
import upload from '../../images/upload.png';
import getCustomerWithLocations from '../../actions/getCustomerWithLocations';
import postCreatePresignedUrl from '../../actions/postCreatePresignedUrl';
import postUploadFileToPresignedUrl from '../../actions/postUploadFileToPresignedUrl';
import postCorrectionRequest from '../../actions/postCorrectionRequest';
import Remove from '@material-ui/icons/Close';

const styles = theme => ({
    paper: {
        width: '85%',
        height: '70%',
        display: 'inline-block',
        margin: 20,
        marginTop: '5vh'
    },
    header: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: 'none',
        boxSizing: 'content-box !important'
    },
    headerTitle: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    cardDiv: {
        display: 'flex',
        boxShadow: 'none',
    },
    cardContent: {
        flex: '1 0 auto'
    },
    marginStyle: {
        margin: '.5em'
    },
    textField: {
        width: 350,
        minWidth: 120,
        textAlign: 'left'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 350,
        minWidth: 120,
    },
    button: {
        marginTop: 15,
        marginBottom: 15,
        display: 'flex',
        justifyContent: 'space-around'
    },
    fileUploadDiv: {
        textAlign: 'center',
        margin: 'auto',
        color: 'grey',
        paddingTop: '10px'
    },
    dropBoxMessage: {
        fontSize: '18pt'
    },
    dropBoxMessageSpan: {
        color: '#002053',
        cursor: 'pointer'
    },
    submissionProgress: {
        display: 'flex',
        justifyContent: 'center',
    },
    submissionProgressList: {
        listStyleType: 'none',
        textAlign: 'left',
    },
    submissionProgressListItem: {
        position: 'relative',
        left: '5px',
        bottom: '6px',
    },
    listOfFiles: {
        display: 'flex',
        width: '400px',
        margin: '0 auto'
    },
    fileListItem: {
        cursor: 'pointer', 
        textAlign: 'left', 
        fontSize: '12pt', 
        display: 'flex',
        padding: '5px 5px 5px 10px',
        borderRadius: '10px', 
        marginRight: '5px', 
        marginBottom: '5px',
        color: 'white',
        backgroundColor: '#002053'
    },
    removeIcon: {
        paddingLeft: '10px', paddingTop: '2px', fontSize: '14px'
    }
});

const defaultRequiredFields = ['emailAddress', 'phoneNumber', 'vin', 'dateOfRecord', 'recordType'];
let requiredFields = [...defaultRequiredFields];
const validate = (values) => {
    const errors = {};

    // check valid email address
    if (values.emailAddress) {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailAddress)) {
            errors.emailAddress = 'Invalid email address';
        }
    }

    // check valid phone number
    if (values.phoneNumber) {
        if (!/\d{3}-\d{3}-\d{4}/i.test(values.phoneNumber)) {
            errors.phoneNumber = 'Invalid phone number';
        }
    }

    // check valid date (e.g. not future date)
    if (values.dateOfRecord) {
        const selectedDate = new Date(values.dateOfRecord);
        const now = new Date();

        if (selectedDate > now) {
            errors.dateOfRecord = `Date of Record must be on or before ${now.toLocaleDateString()}`;
        }
    }

    // if a record type has been selected, add the appropriate required fields
    if (values.recordType) {
        if (values.recordType === 'Auction Data Error') {
            requiredFields = [...defaultRequiredFields, 'incorrectInformation', 'correctInformation'];
            // requiredFields.push('incorrectInformation', 'correctInformation');
        } else {
            requiredFields = [...defaultRequiredFields, 'dmvRecordError'];
            // requiredFields.push('dmvRecordError');
        }
    } else {
        requiredFields = [...defaultRequiredFields];
    }

    // check required fields
    requiredFields.forEach((field) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });

    return errors;
};

class CorrectionRequest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: true,
            fetched: false,
            submitting: false,
            submitted: false,
            recordTypes: ['Auction Data Error', 'Title Odometer Error', 'Title Brand Error'],
            selectedRecordType: '',
            fileUploadedMessage: '',
            phoneNumber: '',
            filesToUpload: [],
            filesAreValid: false,
        };
    }

    componentDidMount() {
        if (this.state.fetched) return;

        const locationId = localStorage.getItem('locationId');
        const location = this.props.data.person.locations.find(l => l.locationId === locationId);
        const { autotecId, customerId } = location;
        const emailAddress = this.props.data.person.email;

        this.props.actions
            .getCustomerWithLocations(customerId, this.props.data.config)
            .then((results) => {
                if (!results || !results.value || !results.value.data || !results.value.data.customer || !results.value.data.customer.Item) return;

                const customer = results.value.data.customer.Item;
                const customerName = customer.name;
                const { phoneNumber } = customer.contact;
                const normalizedPhone = normalizePhone(phoneNumber);

                this.props.initialize({
                    autotecId,
                    customerId,
                    locationId,
                    customerName,
                    emailAddress,
                    phoneNumber: normalizedPhone,
                });

                this.setState({
                    fetching: false,
                    fetched: true,
                    phoneNumber: normalizedPhone,
                });
            });
    }

    validateFilesToUpload = (acceptedFiles) => {
        const maxFileSizeMB = 30;
        const validFileTypes = ['image.*', '.doc', '.docx', 'application/pdf'];

        if (!acceptedFiles) return '';

        let error;
        
        const keys = Object.keys(acceptedFiles);
        for (let i = 0; i < keys.length; i += 1) {
            const file = acceptedFiles[keys[i]];
            if (!validFileTypes.some(type => file.type.match(type))) {
                error = `File '${file.name}' must be an image, word document, or PDF!`;
            }

            if (file.size && ((file.size / 1024 / 1024) >= maxFileSizeMB)) {
                error = `File '${file.name}' size cannot exceed ${maxFileSizeMB} MB!`;
            }
        }

        if (error) {
            this.setState(() => ({
                fileUploadedMessage: error,
                filesAreValid: false,
                filesToUpload: [],
            }));
        } else {
            const filesToUpload = [...this.state.filesToUpload]

            if (!filesToUpload.includes(...acceptedFiles)) {
                filesToUpload.push(...acceptedFiles)
            }

            this.setState(() => ({
                filesToUpload: filesToUpload,
                filesAreValid: true,
            }));
        }
        
        return error;
    };

    renderFileUploadMessage = () => {
        const { fileUploadedMessage, filesAreValid, filesToUpload } = this.state;
        const { classes } = this.props;

        let fileNameArray = [];
        let fileList;

        if (filesAreValid) {
            fileNameArray = filesToUpload.map((file, index) => (
                <li
                    key={index}
                    className={`${classes.fileListItem} reportHover`}
                    onClick={() => this.handleDelete(file.name)}
                >
                    {file.name}
                    <Remove className={classes.removeIcon}  />
                </li>
            ));

            fileList = (
                <div className={classes.listOfFiles} style={{ marginBottom: '5%' }}>
                    <ul style={{
                        listStyle: 'none', padding: '0 0 0 0',
                        display: 'flex', flexWrap: 'wrap', justifyContent: 'center', margin: '5px auto'
                    }}
                    >
                        {fileNameArray}
                    </ul>
                </div>
            )
        }

        let fileUploadError = (
            <span style={{ display: 'flex', justifyContent: 'center', color: 'red' }}>{fileUploadedMessage}</span>
        );

        return filesAreValid ? fileList : fileUploadError;
    }

    handleDelete = (selectedFile) => {
        this.setState(() => ({
            filesToUpload: this.state.filesToUpload.filter(file => selectedFile !== file.name)
        }));
    }

    handleSubmit = (event) => {
        const { config } = this.props.data;
        this.props.actions.submitCorrectionRequest(event, config, this);
    };

    handleRecordTypeChange = (event) => {
        this.setState({ selectedRecordType: event.target.value });
    };

    resetForm = () => {
        // reset form
        this.props.reset('CorrectionRequestForm');

        // change phone number to match state, this will catch situation where user changed phone number
        // and it no longer matches the one set in componentDidMount code
        this.props.change('phoneNumber', this.state.phoneNumber);

        // reset necessary state values back to default values
        this.setState({
            submitting: false,
            submitted: false,
            selectedRecordType: '',
            fileUploadedMessage: '',
            filesToUpload: [],
            filesAreValid: false,
        });
    };

    renderRecordInformation = () => {
        const { submitting, submitted } = this.state;
        const { classes, invalid, pristine } = this.props;

        if (submitted) {
            return (
                <div>
                    <Card className={classes.cardDiv} xs={12} sm={6}>
                        <CardContent className={classes.cardContent}>
                            <Typography variant="title" style={{ fontSize: '18pt' }}>
                                Your request has been successfully submitted!
                            </Typography>
                        </CardContent>
                    </Card>
                    <div style={{ margin: 10 }}>
                        <Button
                            variant="raised"
                            type="button"
                            style={{ width: 'unset', backgroundColor: '#002053', color: '#fff' }}
                            onClick={this.resetForm}
                        >
                            Submit Another Request?
                        </Button>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <Card className={classes.cardDiv} xs={12} sm={6}>
                    <CardContent className={classes.cardContent}>
                        <Field
                            name="vin"
                            label="VIN"
                            component={renderTextField}
                            className={classes.textField}
                            divClassName={classes.marginStyle}
                            normalize={normalizeMaxLength(17)}
                        />
                        <Field
                            name="dateOfRecord"
                            label="Date of Record"
                            component={renderDatePicker}
                            className={classes.textField}
                            divClassName={classes.marginStyle}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <TodayIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Field
                            name="recordType"
                            label="Record Type"
                            component={renderSelectField}
                            className={classes.textField}
                            divClassName={classes.marginStyle}
                            onChange={this.handleRecordTypeChange}
                        >
                            {this.state.recordTypes.map(recordType => (
                                <MenuItem
                                    key={recordType}
                                    value={recordType}
                                >
                                    {recordType}
                                </MenuItem>
                            ))}
                        </Field>
                        { this.renderRecordTypeFields() }
                    </CardContent>
                    <CardContent className={classes.cardContent}>
                        <Field
                            name="filesToUpload"
                            classes={classes}
                            component={this.renderDropzone}
                            validate={this.validateFilesToUpload}
                        />
                        <div style={{ height: '16px', padding: '5px 0', width: '400px', height: '200px', margin: '0 auto' }}>
                            {this.renderFileUploadMessage()}
                        </div>
                    </CardContent>
                </Card>
                {
                    submitting
                        ? this.renderSubmissionProgress()
                        : (
                            <div className={classes.button}>
                                <Button
                                    onClick={this.resetForm}
                                    variant="raised"
                                    type="reset"
                                    style={{ textTransform: 'none', backgroundColor: '#002053', color: 'white', fontSize: '13px' }}
                                >
                                    Reset Form
                                </Button>
                                <Button
                                    variant="raised"
                                    type="submit"
                                    disabled={invalid || pristine || submitting}
                                    style={{ width: 'unset' }}
                                >
                                    Submit Correction
                                </Button>
                            </div>
                        )
                }
            </div>
        );
    };

    renderRecordTypeFields = () => {
        const maxLength = 500;
        const { classes } = this.props;

        switch (this.state.selectedRecordType) {
            case 'Auction Data Error': {
                return (
                    <div>
                        <Field
                            name="incorrectInformation"
                            label="Incorrect Information"
                            component={renderTextAreaWithDiv}
                            className={classes.textField}
                            divClassName={classes.marginStyle}
                            normalize={normalizeMaxLength(maxLength)}
                            rows={8}
                        />
                        <Field
                            name="correctInformation"
                            label="Correct Information"
                            component={renderTextAreaWithDiv}
                            className={classes.textField}
                            divClassName={classes.marginStyle}
                            normalize={normalizeMaxLength(maxLength)}
                            rows={8}
                        />
                    </div>
                );
            }
            case 'Title Brand Error':
            case 'Title Odometer Error': {
                return (
                    <Field
                        name="dmvRecordError"
                        label="DMV Record Problem"
                        component={renderTextAreaWithDiv}
                        className={classes.textField}
                        divClassName={classes.marginStyle}
                        normalize={normalizeMaxLength(maxLength)}
                        rows={8}
                    />
                );
            }
            default:
                return null;
        }
    };

    renderDropzone = ({ input, name, classes }) => (
        <div>
            <ReactDropzone
                name={name}
                onDrop={files => input.onChange(files)}
                multiple
                className="dropzone"
                style={{ width: 350 }}
            >
                <div className={classes.fileUploadDiv}>
                    <img src={upload} alt="File Upload" width={100} height={67} />
                    <br /><br />
                    <p className={classes.dropBoxMessage}>
                        Upload Supporting <span className={classes.dropBoxMessageSpan}>Documentation</span>
                    </p>
                </div>
            </ReactDropzone>
        </div>
    );

    renderSubmissionProgress = () => {
        const { submitting } = this.state;
        if (!submitting || !submitting.length) return <CircularProgress size={50} style={{ padding: '24px 0' }} />;

        const { classes } = this.props;
        return (
            <div className={classes.submissionProgress}>
                <ul className={classes.submissionProgressList}>
                    {
                        submitting.map(f => (
                            <li key={f.name}>
                                {f.uploading ? <CircularProgress size={25} /> : <CheckCircleIcon style={{ color: 'green' }} />}
                                <span className={classes.submissionProgressListItem}>{f.name}</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        );
    };

    render() {
        // touch required fields so they will show they are required immediately
        this.props.touch('CorrectionRequestForm', ...requiredFields);

        const { classes, handleSubmit } = this.props;
        const { fetching } = this.state;

        return (
            <Layout
                className="App"
                showMenu
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                {
                    fetching
                        ? <div style={{ textAlign: 'center', padding: 10 }}><CircularProgress size={75} /></div>
                        : <Form key="CorrectionRequestForm" onSubmit={handleSubmit(event => this.handleSubmit(event))}>
                            <Paper className={classes.paper}>
                                <AppBar position="static" className={classes.header}>
                                    <Toolbar className={classes.headerTitle}>
                                        <Typography variant="title" style={{ fontSize: '24pt' }}>
                                            Customer Information
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                <Card className={classes.cardDiv} xs={12} sm={6}>
                                    <CardContent className={classes.cardContent}>
                                        <Field
                                            disabled
                                            name="autotecId"
                                            label="AutoTec ID"
                                            component={renderTextField}
                                            className={classes.textField}
                                            divClassName={classes.marginStyle}
                                        />
                                        <Field
                                            disabled
                                            name="customerName"
                                            component={renderTextField}
                                            label="Customer"
                                            className={classes.textField}
                                            divClassName={classes.marginStyle}
                                            value={this.state.customerName}
                                        />
                                    </CardContent>
                                    <CardContent className={classes.cardContent}>
                                        <Field
                                            disabled
                                            name="emailAddress"
                                            component={renderTextField}
                                            label="Email"
                                            className={classes.textField}
                                            divClassName={classes.marginStyle}
                                        />
                                        <Field
                                            name="phoneNumber"
                                            component={renderTextField}
                                            label="Phone"
                                            normalize={normalizePhone}
                                            className={classes.textField}
                                            divClassName={classes.marginStyle}
                                            onChange={event => this.setState({ phoneNumber: event.target.value })}
                                        />
                                    </CardContent>
                                </Card>
                            </Paper>
                            <Paper className={classes.paper} style={{ marginTop: '2vh' }}>
                                <AppBar position="static" className={classes.header}>
                                    <Toolbar className={classes.headerTitle}>
                                        <Typography variant="title" style={{ fontSize: '24pt' }}>
                                            Record Information
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                { this.renderRecordInformation() }
                            </Paper>
                          </Form>
                }
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    data: {
        person: state.person.person,
        config: state.config.config,
    }
});

const mapDispatchToProps = dispatch => ({
    actions: {
        getCustomerWithLocations: (customerId, config) => dispatch(getCustomerWithLocations(customerId, config)),
        submitCorrectionRequest: (event, config, self) => {
            self.setState({ submitting: true });

            // build correction request from form
            const correctionRequest = {
                autotecId: event.autotecId,
                email: event.emailAddress,
                customerName: event.customerName,
                customerId: event.customerId,
                locationId: event.locationId,
                phoneNumber: event.phoneNumber,
                vin: event.vin,
                date: event.dateOfRecord,
                uploadedFiles:  [],
            };

            if (event.recordType === 'Auction Data Error') {
                correctionRequest.auctionDataError = {
                    incorrectInformation: event.incorrectInformation,
                    correctInformation: event.correctInformation
                };
            } else if (event.recordType === 'Title Brand Error') {
                correctionRequest.titleBrandError = event.dmvRecordError;
            } else {
                correctionRequest.titleOdometerError = event.dmvRecordError;
            }

            // build params for s3 presigned url and upload
            const millis = Date.now();
            const bucket = `autotec-${getEnvironmentFromUrl()}-supporting-documents`;
            const method = 'post';

            // create a promise for each file upload
            const fileUploads = [];
            if (self.state.filesToUpload) {
                self.state.filesToUpload.forEach((file) => {
                    // aca/corrections/customerId/locationId/milliseconds/filename.extension
                    const key = `aca/corrections/${correctionRequest.customerId}/${correctionRequest.locationId}/${millis}/${file.name}`;
                    correctionRequest.uploadedFiles = [...correctionRequest.uploadedFiles, key];

                    fileUploads.push(dispatch(postCreatePresignedUrl(bucket, key, method, config))
                        // then, upload file to presigned url
                        .then((response) => {
                            self.setState({ submitting: [...self.state.submitting, { name: file.name, uploading: true }] });

                            const { url, fields } = response.value.data.preSignedUrl;
                            return dispatch(postUploadFileToPresignedUrl(url, fields, file, bucket))
                                .then(() => {
                                    const { submitting } = self.state;
                                    const index = submitting.findIndex(f => f.name === file.name);
                                    if (index === -1) return;

                                    submitting[index].uploading = false;

                                    self.setState({ submitting });
                                });
                        }));
                });
            }

            // upload all files in parallel
            Promise.all(fileUploads)
                // then, update UI
                .then(() => self.setState({ submitting: [...self.state.submitting, { name: 'Correction Request', uploading: true }] }))
                // then, submit correction request
                .then(() => dispatch(postCorrectionRequest(correctionRequest, config)))
                // then, update UI
                .then(() => self.setState({ submitting: false, submitted: true }))
                // catch any errors
                .catch(error => self.setState({ error, submitting: false, submitted: false }));
        },
    },
});

const CorrectionRequestForm = withStyles(styles)(reduxForm({
    form: 'CorrectionRequestForm',
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(CorrectionRequest));

const ConnectedCorrectionRequest = connect(
    mapStateToProps,
    mapDispatchToProps
)(CorrectionRequestForm);

export default ConnectedCorrectionRequest;


// WEBPACK FOOTER //
// ./src/components/Account/CorrectionRequest.js